import './ErrorMessage.scss';

const ErrorMessage = ({ error }) => {
  return <div className="ErrorMessage">{error}</div>;
};

export default ErrorMessage;
